import TableInfluences from './table'

export default TableInfluences
